// extracted by mini-css-extract-plugin
module.exports = {"buttons":"UploadResult_buttons_1DdMT","preview":"UploadResult_preview_2lXzc"};